import * as Yup from 'yup';

import {
  CreateBrokerageField,
  getBrokerageFieldRequiredErrorMessage,
  getBrokerageFieldRequiredErrorMessageforAddress,
  getBrokerageFieldWrongTypeErrorMessage,
} from '@converge/data';

export const stringRequired = (fieldName: CreateBrokerageField) => {
  return Yup.string()
    .typeError(getBrokerageFieldWrongTypeErrorMessage(fieldName))
    .required(getBrokerageFieldRequiredErrorMessage())
    .trim()
    .min(1, getBrokerageFieldWrongTypeErrorMessage(fieldName));
};
export const stringaddressRequired = (fieldName: CreateBrokerageField) => {
  return Yup.string()
    .typeError(getBrokerageFieldRequiredErrorMessageforAddress(fieldName))
    .required(getBrokerageFieldRequiredErrorMessageforAddress(fieldName))
    .trim()
    .min(1, getBrokerageFieldRequiredErrorMessageforAddress(fieldName));
};

export const NumberRequired = () => {
  return Yup.number()
    .nullable()
    .transform(
      (value, originalValue) => (originalValue === '' ? null : value) // Convert empty string to null
    )
    .optional()
    .typeError('Enter Number') // Error message for non-numeric input
    .min(1, 'Enter 1-100') // Minimum value validation
    .max(100, 'Enter 1-100'); // Maximum value validation
};

export const CreateBrokerFieldsSchema = Yup.object({
  [CreateBrokerageField.CompanyName]: stringRequired(
    CreateBrokerageField.CompanyName
  ),
  [CreateBrokerageField.DbaName]: Yup.string().optional().nullable(),
  [CreateBrokerageField.Domain]: Yup.string().optional(),
  [CreateBrokerageField.GlobalParentCompany]: Yup.string()
    .optional()
    .nullable(),
  [CreateBrokerageField.PartnerEntity]: Yup.string().optional().nullable(),
  [CreateBrokerageField.Fein]: Yup.string().optional(),
  [CreateBrokerageField.Npn]: Yup.string().optional(),
  [CreateBrokerageField.ProgramUuid]: Yup.string().optional(),
  [CreateBrokerageField.CoverageRegionUuid]: Yup.string().optional(),
  [CreateBrokerageField.PrimaryStreet1]: stringaddressRequired(
    CreateBrokerageField.PrimaryStreet1
  ),
  [CreateBrokerageField.Street1]: stringaddressRequired(
    CreateBrokerageField.Street1
  ),
  [CreateBrokerageField.PrimaryStreet2]: Yup.string().optional(),
  [CreateBrokerageField.PrimaryCity]: stringaddressRequired(
    CreateBrokerageField.PrimaryCity
  ),
  [CreateBrokerageField.PrimaryRegionUuid]: stringaddressRequired(
    CreateBrokerageField.PrimaryRegionUuid
  ),
  [CreateBrokerageField.PrimaryCountryUuid]: stringaddressRequired(
    CreateBrokerageField.PrimaryCountryUuid
  ),
  [CreateBrokerageField.PrimaryPostalCode]: stringaddressRequired(
    CreateBrokerageField.PrimaryPostalCode
  ),
  [CreateBrokerageField.Street2]: Yup.string().optional(),
  [CreateBrokerageField.City]: stringaddressRequired(CreateBrokerageField.City),
  [CreateBrokerageField.RegionUuid]: stringaddressRequired(
    CreateBrokerageField.RegionUuid
  ),
  [CreateBrokerageField.CountryUuid]: stringaddressRequired(
    CreateBrokerageField.CountryUuid
  ),
  [CreateBrokerageField.PostalCode]: stringaddressRequired(
    CreateBrokerageField.PostalCode
  ),
  [CreateBrokerageField.PrimaryPhoneNumber]: Yup.string().optional(),
  [CreateBrokerageField.Digital]: NumberRequired(),

  [CreateBrokerageField.Wholesale]: NumberRequired(),
  [CreateBrokerageField.BusinessDevelopmentManager]: Yup.string()
    .optional()
    .nullable(),
  [CreateBrokerageField.UwRegion]: Yup.string().optional().nullable(),
  [CreateBrokerageField.BdmRegion]: Yup.string().optional().nullable(),
  [CreateBrokerageField.Underwriter]: Yup.string().optional().nullable(),
});
